export const WORKSPACE_TAB = "WORKSPACE";
export const PROJECTS_TAB = "PROJECTS";
export const B2B_TAB = "B2BCUSTOMERS";
export const OPPORTUNITIES = "OPPORTUNITIES";
export const BRM_TAB = "BRM";
export const APPLES_TAB = "APPLES";
export const BANANAS_TAB = "BANANAS";

export const getActiveTabPanelId = (): string => {
  const currentPath = window.location.pathname;
  if (
    currentPath.includes("/workspace/") ||
    currentPath.includes("/saleslead/workspace/")
  ) {
    return "WORKSPACE_TAB";
  }

  if (currentPath.includes("/bas/business-customers/")) {
    return "B2B_TAB";
  }

  if (currentPath.includes("/bas/leads/")) {
    return "OPPORTUNITIES";
  }

  if (currentPath.includes("/brm/")) {
    return "BRM_TAB";
  }

  if (currentPath.includes("/saleslead/") || currentPath === "/") {
    return "PROJECTS_TAB";
  }
  if (currentPath.includes("/saleslead/apples/")) {
    return "APPLES_TAB";
  }

  if (currentPath.includes("/saleslead/bananas/")) {
    return "BANANAS_TAB";
  }

  return "PROJECTS_TAB";
};
